import { render } from "./UserInfoView.vue?vue&type=template&id=f038d1be"
import script from "./UserInfoView.vue?vue&type=script&lang=js"
export * from "./UserInfoView.vue?vue&type=script&lang=js"

import "./UserInfoView.vue?vue&type=style&index=0&id=f038d1be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__